import { css } from '@emotion/react';
import { ThemeType } from 'radiance-ui/lib/constants';

export const newYearPromoBannerStyles = (theme: ThemeType) => css`
  background: #be247a;
  color: ${theme.COLORS.white};
`;
